const cn =  {
    logo: '资产管理系统',
    menu: {
        user: '个人信息',
        mine: '我的IT日常资产',
        stock: 'IT日常资产盘点',
        yearStock: '资产年度盘点',
        myStock: '我的资产年度盘点',
        req: '资产申请',
        out: '出库',
        stocked: 'IT日常资产盘点记录',
        take: '资产领用',
        hand: '资产转移',
        ipadStock: 'IPAD日常资产盘点',
        myIpadStock: '我的IPAD日常资产'
    },
    submit: '提交',
    submitTip: '提交中',
    assetNum: '资产编号',
    assetNumTip: '扫码或手动输入资产编号',
    // photoTip1: '拍照上传资产照片',
    photoTip1: '请上传收到资产的标签照片',
    photoTip2: '设备实物拍照上传',
    question: '是否有疑问',
    remarks: '备注',
    remarksTip: '请描述资产错误信息', //请输入备注
    personalInfo: '个人信息',
    username: '员工号',
    mobile: '手机号',
    realname: '姓名',
    modifyInfo: '修改信息',
    language: '语言选择',
    stock: '盘点',
    stocked: '已盘点',
    supervisor: '监盘',
    supervisored: '已监盘',
    details: '详情',
    confirm: '确认',
    error_message_submit: '错误信息提交',
    assetDetails: '资产详情',
    inStock: '盘点中',
    heldby: '使用人',
    heldbyTip: '请输入使用人姓名或手机号',
    dept: '部门',
    location: '位置',
    stockPerson: '盘点人',
    stockTime: '盘点时间',
    signTime: '签收时间',
    signStatus: '签收状态',
    signPeople: '签收人',
    serial: '序列号',
    storage: '保管人',
    model: '资产型号',
    mobile_company: '签收手机号码',
    bu:'BU',
    user_name: '使用人姓名',
    phone: '联系电话',
    sign_time: '领用时间',
    n_name:'N+1 姓名',
}
export default cn;
